import React, { useState, useEffect } from "react";
import DataServiceSQL from "../../DataService/DataServiceSQL";
import { Row, Col } from 'reactstrap';
import { withStyles } from '@material-ui/core';
import * as Constants from '../../Pages/Constants';
import {FormattedMessage} from 'react-intl';

const AddDevice = (props) => {
  const [device, setDevice] = useState({id_device: "", sn: "", nickname: "", FK_structure: ""});
  const [submitted, setsubmitted] = useState(false);
  const [message, setmessage] = useState("a");

  useEffect(() => {
  }, []);


  const handleInputChange = event => {
    const { name, value } = event.target;
    setDevice({ ...device, [name]: value });
  };

  const saveDevice = () => {
    var data = {
      resourceType: "Device",
      type: "Sensor",
      serialNumber: device.sn,
      name: device.nickname
    };

    DataServiceSQL.createDeviceReq_fhir(data)
      .then(response => {
        if (typeof(response.data) === "object") {
          setmessage(<FormattedMessage id="message.success" defaultMessage="Success !" />);
          setsubmitted(true);
        }
        else {
          setmessage(<FormattedMessage id="message.error.adddevice" defaultMessage="Oups, did not work... (err_code adddevice)" />);
          setsubmitted(true);
        }
      })
      .catch(e => {
        setmessage(<FormattedMessage id="message.error.adddevice" defaultMessage="Oups, did not work... (err_code adddevice)" />);
        setsubmitted(true);
      });
  };

  const { classes } = props;

  return (
    <div className={classes.popup_background}>
      <div style={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "center"}}>
        <div className="submit-form">
          {(submitted) ? (
            <div>
              <center>
                <h4>{message}</h4>
                <button onClick={props.closeAfterAdd} className="btn btn-success">
                    <FormattedMessage id="button.close" defaultMessage="Close" />
                </button>
              </center>
            </div>
          ) : (
            <div>
              <center>
                <div>
                  <Row className="justify-content-md-end">
                    <Col style={{ fontWeight: "bold", fontSize:"2.0em" }}>
                      <FormattedMessage id="device.add" defaultMessage="Add Device" />
                    </Col>
                  </Row>
                </div>
                <br/>
                <div className="form-group" style={{paddingTop:"5%"}}>
                  <label htmlFor="sn">
                    <FormattedMessage id="device.name" defaultMessage="Serial number" />
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="sn"
                    required
                    value={device.sn}
                    onChange={handleInputChange}
                    name="sn"
                  />
                </div>
                <div className="form-group" style={{paddingTop:"5%"}}>
                  <label htmlFor="sn">
                    <FormattedMessage id="device.nickname" defaultMessage="Nickname" />
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="nickname"
                    required
                    value={device.nickname}
                    onChange={handleInputChange}
                    name="nickname"
                  />
                </div>
                <br/>
                <button onClick={props.cancelPopup} className="btn btn-danger">
                  <FormattedMessage id="button.cancel" defaultMessage="Cancel" />
                </button>
                <b>&emsp;</b> 
                <button onClick={saveDevice} className="btn btn-success">
                  <FormattedMessage id="button.submit" defaultMessage="Submit" />
                </button>
              </center>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default withStyles(Constants.styles)(AddDevice);
